export type Testable<T> = T & { 'data-test-id'?: string };
export type Tourable<T> = T & { 'guided-tour-id'?: string };

export enum NotificationType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
}
